import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

interface GlassPillProps {
  text: string;
  onRemove: () => void;
}

export function GlassPill({ text, onRemove }: GlassPillProps) {
  return (
    <motion.span
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm text-white"
      style={{
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.12)',
      }}
    >
      {text}
      <button
        type="button"
        onClick={onRemove}
        className="transition-colors rounded-full p-0.5 hover:bg-white/10"
        style={{ color: 'rgba(255, 255, 255, 0.5)' }}
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </motion.span>
  );
}
